import React from 'react';
import { Heart } from 'lucide-react';
import { SOCIAL_ICONS, SOCIAL_LINKS } from '@/constants/socialLinks';

const NAV_ITEMS = [
  { title: 'About Rahul', href: '#about' },
  { title: 'Join Movement', href: '#join' },
  { title: 'Stories', href: '#stories' },
  { title: 'Events', href: '#events' },
  { title: 'Volunteer Zone', href: '#join' }
];

const RESOURCE_LINKS = [
  { title: 'Media Library', href: '#media' },
  { title: 'Press Releases', href: '#media' },
  { title: 'Contact', href: '#contact' }
];



const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img src="/logo.jpeg" alt="Mera PM Rahul Logo" className="w-12 h-12 rounded-lg" />
              <div>
                <h3 className="text-xl font-bold">MeraPMRahul</h3>
                <p className="text-xs text-blue-200">मेरा प्रधानमंत्री राहुल</p>
              </div>
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              A people's movement for truth, trust, and transformation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {NAV_ITEMS.map((link) => (
                <li key={link.title}>
                  <a href={link.href} className="text-blue-200 hover:text-white transition-colors">
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-lg mb-4">Resources</h4>
            <ul className="space-y-2">
              {RESOURCE_LINKS.map((link) => (
                <li key={link.title}>
                  <a href={link.href} className="text-blue-200 hover:text-white transition-colors">
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-2 text-blue-200 text-sm">
              <li>merapmrahulgandhi@gmail.com</li>
              <li>+91 99883 65265</li>
              <li>+91 91315 95022</li>
              <li className="pt-2">
                <span className="block font-semibold text-white mb-2">Follow Us:</span>
                <div className="flex flex-wrap gap-2 md:gap-2">
                  {Object.entries(SOCIAL_LINKS).map(([key, { url, name }]) => (
                    <a
                      key={key}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={name}
                      className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center cursor-pointer transition-colors text-white"
                    >
                      {SOCIAL_ICONS[key]}
                    </a>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-800 pt-8">
          <div className="mt-4 text-center">
            <p className="text-sm text-blue-300 italic">
              "जो सुने, जो चले, जो सच्चाई के साथ खड़ा रहे, वही मेरा प्रधानमंत्री है।"
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-8">
            <p className="text-blue-200 text-xs md:text-sm text-center md:text-left">
              © {new Date().getFullYear()} MeraPMRahul.com. All rights reserved.
            </p>
            <p className="text-blue-200 text-xs md:text-sm flex flex-col md:flex-row items-center justify-center md:justify-start gap-1 md:gap-2">
              <span>Developed with</span>
              <Heart className="text-red-400" size={14} fill="currentColor" />
              <span>by WithRG and BoothMitra Team</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
